// Public contact channels. WhatsApp is staffed by the same chatbot that backs
// the support line, so it is offered alongside every published email address.
export const WHATSAPP_NUMBER = "27655850034";
export const WHATSAPP_DISPLAY = "+27 65 585 0034";
export const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_NUMBER}`;
